import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import InputDate from './InputDate';
import consts from '../libs/consts';

import Radios from './Radios';
import Checkbox from './Checkbox';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { getBase64, getBase64toDataUrl, getMemberinfo, numFormat, geKoreanNumber } from '../utils/utils';
import InfoViewlists from './InfoViewlists';
import * as APIS from "../utils/service";
import DatePicker from "react-datepicker";

export default function ContractwriterPageViewer(props) {

    const {
        row={},
    } = props;
    const [sell_type, setsell_type] = useState('매매');   
    const [category, setcategory] = useState('집합건물');
    const [togetherck, settogetherck] = useState([]); 
    const [memberinfos, setmemberinfos] = useState(''); 
    const [totalheightSize, settotalheightSize] = useState(''); 
    const [page, setpage] = useState(1); 
    const [totalpage, settotalpage] = useState(0); 
    const [commentHeight, setcommentHeight] = useState(276); 
    const divRef = useRef(null);
    
    const [inputArr, setinputArr] = useState([
        {keys: "소재지", values: '', requireCkr: true, errmsg: '소재지를 입력해주세요.'},
        {keys: "소재지동", values: '', requireCkr: false, errmsg: '소재지동을 입력해주세요.'},
        {keys: "소재지호", values: '', requireCkr: false, errmsg: '소재지호를 입력해주세요.'},
        {keys: "토지지목", values: '대', requireCkr: false, errmsg: '토지지목을 입력해주세요.'},
        {keys: "토지면적", values: '', requireCkr: false, errmsg: '토지면적을 입력해주세요.'},
        {keys: "대지권목적", values: '', requireCkr: false, errmsg: '대지권목적을 입력해주세요.'},
        {keys: "대지권면적", values: '', requireCkr: false, errmsg: '대지권면적을 입력해주세요.'},
        {keys: "대지권종류", values: '', requireCkr: false, errmsg: '대지권종류를 입력해주세요.'},
        {keys: "대지권비율", values: '', requireCkr: false, errmsg: '대지권비율을 입력해주세요.'},
        {keys: "대지권비율2", values: '', requireCkr: false, errmsg: '대지권비율2을 입력해주세요.'},
        {keys: "건물구조", values: '철근콘크리트구조', requireCkr: false, errmsg: '건물구조를 입력해주세요.'},
        {keys: "건물용도", values: '직접입력', requireCkr: false, errmsg: '건물용도를 입력해주세요.'},
        {keys: "건물전용면적", values: '', requireCkr: false, errmsg: '건물전용면적을 입력해주세요.'},
        {keys: "건물연면적", values: '', requireCkr: false, errmsg: '건물연면적을 입력해주세요.'},
        {keys: "임대할부분", values: '', requireCkr: false, errmsg: '임대할부분을 입력해주세요.'},
        {keys: "임대할면적", values: '', requireCkr: false, errmsg: '임대할면적을 입력해주세요.'},
        {keys: "매매대금", values: '', requireCkr: false, errmsg: '매매대금을 입력해주세요.'},
        {keys: "보증금", values: '', requireCkr: false, errmsg: '보증금을 입력해주세요.'},
        //{keys: "현임대보증금", values: '', requireCkr: false, errmsg: '현임대보증금을 입력해주세요.'},
        {keys: "계약금", values: '', requireCkr: false, errmsg: '계약금을 입력해주세요.'},
        {keys: "영수자", values: '', requireCkr: false, errmsg: '영수자를 입력해주세요.'},
        ///{keys: "융자금", values: '', requireCkr: false, errmsg: '융자금을 입력해주세요.'},
        {keys: "중도금", values: [
            {keys: "중도금1", values: [
                {keys: "중도금", values: '', requireCkr: false, errmsg: '두번째 중도금을 입력해주세요.'},
                {keys: "중도금지불일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
                {keys: "중도금지불일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
                {keys: "중도금지불일일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
            ], requireCkr: false, errmsg: '중도금을 입력해주세요.'},
        ], requireCkr: false, errmsg: '중도금을 입력해주세요.'},
        {keys: "잔금", values: '', requireCkr: false, errmsg: '잔금을 입력해주세요.'},
        {keys: "잔금년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "잔금월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "잔금일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "차임", values: '', requireCkr: false, errmsg: '차임을 입력해주세요.'},
        {keys: "차임일", values: moment().format('DD'), requireCkr: false, errmsg: '차임일을 선택해주세요.'},
        {keys: "부동산인도일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산인도일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산인도일일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "부동산임대차인도일개월", values: '', requireCkr: false, errmsg: '소재지를 입력해주세요.'},        
        {keys: "쌍방교부년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "쌍방교부월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "쌍방교부일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "특약사항", values: [
            {keys: "특약사항", values: '', requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        ], requireCkr: false, errmsg: '특약사항을 입력해주세요.'},

        {keys: "날인일년", values: moment().format('YYYY'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "날인일월", values: moment().format('MM'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "날인일", values: moment().format('DD'), requireCkr: false, errmsg: '소재지를 입력해주세요.'},
        {keys: "매도인", values: [
            {keys: "매도인1", values: [
                {keys: "매도인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "매도인주민번호선택", values: '', requireCkr: false, errmsg: ''},
                {keys: "매도인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "매도인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "매도인성명", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호선택", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인성명", values: '', requireCkr: false, errmsg: ''},
            ], requireCkr: false, subflag: false, errmsg: '중도금을 입력해주세요.'},
        ], requireCkr: false, errmsg: '매도인정보를 입력해주세요.'},
        {keys: "매수인", values: [
            {keys: "매수인", values: [
                {keys: "매수인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "매수인주민번호선택", values: '', requireCkr: false, errmsg: ''},
                {keys: "매수인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "매수인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "매수인성명", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주소", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호선택", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인전화", values: '', requireCkr: false, errmsg: ''},
                {keys: "대리인성명", values: '', requireCkr: false, errmsg: ''},
            ], requireCkr: false, subflag: false, errmsg: '중도금을 입력해주세요.'},
        ], requireCkr: false, errmsg: '매수인정보를 입력해주세요.'},
        {keys: "개중사무소소재지1", values: memberinfos?.compony?.addr, requireCkr: false, errmsg: '개업공인중개 사사무소소재지를 입력해주세요.'},
        {keys: "개중사무소명칭1", values: memberinfos?.compony?.title, requireCkr: false, errmsg: '개업공인중개사 사무소명칭을 입력해주세요.'},
        {keys: "개중전화번호1", values: memberinfos?.hp, requireCkr: false, errmsg: '개업공인중개사 전화번호를 입력해주세요.'},
        {keys: "개중등록번호1", values: memberinfos?.compony?.permit_number, requireCkr: false, errmsg: '개업공인중개사 등록번호를 입력해주세요.'},
        {keys: "공동중개여부", values: '', requireCkr: false, errmsg: '공동중개여부를 선택해주세요.'},
        {keys: "공동중개", values: [
            {keys: "공동중개1", values: [
                {keys: "공동중개사무소소재지", values: '', requireCkr: false, errmsg: ''},
                {keys: "공동중개사무소명칭", values: '', requireCkr: false, errmsg: ''},
                {keys: "공동중개전화번호", values: '', requireCkr: false, errmsg: ''},
                {keys: "공동중개등록번호", values: '', requireCkr: false, errmsg: ''},
            ], requireCkr: false, subflag: false, errmsg: ''},
        ], requireCkr: false, errmsg: '공동중개정보를 입력해주세요.'},
    ]);
    
    useEffect(() => {
        if(row?.idx){
            console.log(row);

            let inputArrData = JSON?.parse(row?.contract);
            setsell_type(row?.sell_type);
            setcategory(row?.category);
            if(inputArrData){
                setinputArr(inputArrData);
                if(inputArrData?.find(item => item?.keys === '공동중개여부')?.values){
                    settogetherck(inputArrData?.find(item => item?.keys === '공동중개여부')?.values);
                } else {
                    settogetherck([]);
                }
            }
            let sumHeight = 0;
            if(inputArrData?.find(item => item?.keys === '매도인')?.values[0]?.subflag === true){
                sumHeight = sumHeight+49;
            }
            if(inputArrData?.find(item => item?.keys === '매수인')?.values[0]?.subflag === true){
                sumHeight = sumHeight+49;
            }
            console.log(sumHeight, sumHeight, sumHeight, sumHeight, sumHeight);
            setcommentHeight(commentHeight-sumHeight);

        } else {
            setsell_type('매매');
            setcategory('집합건물');
        }
    }, [row]);
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        if (divRef.current) {
            console.log(divRef);
            const offsetHeight = divRef.current.scrollHeight;
            settotalheightSize(offsetHeight);
            settotalpage(Math.ceil(offsetHeight/1116));
        }
    }, [divRef]);

    let subarrheight = 0;
    let midpricecount = 1;
    let commentcount = 1;
    let buyercount = 1;
    let sellercount = 1;
    let togethercount = 0;
    //let totalcounts = midpricecount+commentcount+buyercount+sellercount+togethercount;

    inputArr?.find(item => item?.keys === '중도금')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+26; }); //+20
    inputArr?.find(item => item?.keys === '특약사항')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+280; });
    inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+(x?.subflag ? 98 : 49); });
    inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+(x?.subflag ? 98 : 49); });
    inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => { if(i > 0) subarrheight = subarrheight+78; });
    let pageArr = [];
    if(subarrheight > 0){
        subarrheight = (subarrheight+50)+(Math.ceil(subarrheight/1116)*174);
        let subpagecount = Math.ceil(subarrheight/1116);
        for(let p = 0; p < subpagecount; p++){
            pageArr.push({page: p+1});
        }
    } else {
        subarrheight = 0;
        //pageArr.push({page: 0});
    }

    let colorarr = ['yellow','green','blue','orange','purple','lightblue','lighegreen','','','','','',''];
    return (
        <>
        {/* <div style={{ backgroundColor: 'red', height: 1116, overflow: 'auto' }} ref={divRef}> */}
        <div style={{ }} ref={divRef}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: 10}} >
                <div 
                    className='fontsize12' 
                    style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8
                    }}
                >
                    <div style={{ fontSize: 20, fontWeight: 700}}>
                        {category} {sell_type} 계약서
                    </div>
                </div>
                
                <div 
                    className='fontsize12' style={{ width: '100%', }}
                >
                    <table className='contractTable' style={{ borderBottom: '0px solid #000'}}>
                        <tr>
                            <th colSpan={30}>
                                <p>매도인과 매수인 쌍방은 아래 표시 부동산에 관하여 다음 계약 내용과 같이 매매계약을 체결한다.</p>
                                <p className='bolds ' style={{ marginTop: 3 }}>1.부동산의 표시</p>
                            </th>
                        </tr>
                        <tr>
                            <th className='justifys' colSpan={3}>소 재 지</th>
                            <td colSpan={27}>
                                {inputArr?.find(item => item?.keys === '소재지')?.values}&nbsp;
                                {inputArr?.find(item => item?.keys === '소재지동')?.values}동&nbsp;
                                {inputArr?.find(item => item?.keys === '소재지호')?.values}호
                            </td>
                        </tr>
                        {category === '일반건물' &&
                        <tr>
                            <th className='justifys' colSpan={3} >토 지</th>
                            <th className='justifys' colSpan={2} >지 목</th>
                            <td colSpan={17}>
                                {inputArr?.find(item => item?.keys === '토지지목')?.values}
                            </td>
                            <th className='justifys' colSpan={3} >면 적</th>
                            <td colSpan={5}>
                                {inputArr?.find(item => item?.keys === '토지면적')?.values}㎡
                            </td>
                        </tr>}
                        {category === '집합건물' &&
                        <tr>
                            <th className='justifys' colSpan={3} >대 지 권</th>
                            <th className='justifys' colSpan={2} >지목</th>
                            <td colSpan={4}>
                                {inputArr?.find(item => item?.keys === '토지지목')?.values}
                            </td>
                            <th className='justifys' colSpan={2} >면 적</th>
                            <td colSpan={4}>
                                {inputArr?.find(item => item?.keys === '대지권면적')?.values}㎡
                            </td>
                            <th className='justifys' colSpan={3} >대지권종류</th>
                            <td colSpan={4}>
                                {inputArr?.find(item => item?.keys === '대지권종류')?.values}
                            </td>
                            <th className='justifys' colSpan={3} >대지권비율</th>
                            <td colSpan={5}>
                            {inputArr?.find(item => item?.keys === '대지권비율')?.values}분의 {inputArr?.find(item => item?.keys === '대지권비율2')?.values}
                            </td>
                        </tr>      
                        }              
                        <tr>
                            <th className='justifys' colSpan={3} >건 물</th>
                            <th className='justifys' colSpan={2} >구 조</th>
                            <td colSpan={5} style={{ fontSize: 11 }}>
                                {inputArr?.find(item => item?.keys === '건물구조')?.values}
                            </td>
                            <th className='justifys' colSpan={2} >용 도</th>
                            <td colSpan={5} style={{ fontSize: 11 }}>
                                {inputArr?.find(item => item?.keys === '건물용도')?.values}
                            </td>
                            <th className='justifys' colSpan={3} style={{ letterSpacing: -1 }}>전 용 면 적</th>
                            <td colSpan={2}>
                                {inputArr?.find(item => item?.keys === '건물전용면적')?.values}㎡
                            </td>
                            <th className='justifys' colSpan={3} >연 면 적</th>
                            <td colSpan={5}>
                                {inputArr?.find(item => item?.keys === '건물연면적')?.values}㎡
                            </td>
                        </tr>
                        {(sell_type === '전세' || sell_type === '월세') &&
                        <tr>
                            <th className='justifys' colSpan={3} style={{ letterSpacing: -1 }} >임대할 부분</th>
                            <td colSpan={19}>
                                {inputArr?.find(item => item?.keys === '임대할부분')?.values}
                            </td>
                            <th className='justifys' colSpan={3} >면 적</th>
                            <td colSpan={5}>
                                {inputArr?.find(item => item?.keys === '임대할면적')?.values}㎡
                            </td>
                        </tr>
                        }
                        <tr>
                            <th colSpan={30}>
                                <p className='bolds'>2. 계약내용</p>
                                <p style={{ marginTop: 3 }}>제1조 (목적) 위 부동산의 매매에 대하여 매도인과 매수인은 합의에 의하여 매매대금을 아래와 같이 지불하기로 한다.</p>
                            </th>
                        </tr>
                        {sell_type === '매매' &&
                        <tr>
                            <th className='justifys' colSpan={3} >매 매 대 금</th>
                            <td colSpan={27} style={{ fontSize: 16, fontWeight: 700 }}>
                                금 {geKoreanNumber(inputArr?.find(item => item?.keys === '매매대금')?.values*10000)}원정
                                (₩{numFormat(inputArr?.find(item => item?.keys === '매매대금')?.values*10000)})
                            </td>
                        </tr>}
                        {sell_type !== '매매' &&
                        <tr>
                            <th className='justifys' colSpan={3} >보 증 금</th>
                            <td colSpan={27} style={{ fontSize: 16, fontWeight: 700 }}>
                                금 {geKoreanNumber(inputArr?.find(item => item?.keys === '보증금')?.values*10000)}원정
                                (₩{numFormat(inputArr?.find(item => item?.keys === '보증금')?.values*10000)})
                            </td>
                        </tr>}
                        
                        <tr>
                            <th className='justifys' colSpan={3} >계 약 금</th>
                            <td colSpan={20} style={{ fontSize: 16, fontWeight: 700 }}>
                                    금 {geKoreanNumber(inputArr?.find(item => item?.keys === '계약금')?.values*10000)}원은 계약시 지불하고 영수함.                    
                            </td>
                            <th className='justifys' colSpan={3} >영 수 자</th>
                            <td colSpan={4} style={{ textAlign: 'right' }}>
                                {inputArr?.find(item => item?.keys === '영수자')?.values}
                                (인)
                            </td>
                        </tr>
                        {inputArr?.find(item => item?.keys === '중도금')?.values?.map((x, i) => {
                            let rowspan = inputArr?.find(item => item?.keys === '중도금')?.values?.length;
                            let values = x?.values?.find(item => item?.keys === '중도금')?.values;
                            let values1 = x?.values?.find(item => item?.keys === '중도금지불일년')?.values;
                            let values2 = x?.values?.find(item => item?.keys === '중도금지불일월')?.values;
                            let values3 = x?.values?.find(item => item?.keys === '중도금지불일일')?.values;
                            let indexNumber = i;
                            if(i > 0) return;
                            if(values*1 > 0){
                                return (
                                    <tr>
                                        {i === 0 &&
                                        <th className='justifys' colSpan={3} rowSpan={1} >중 도 금</th>
                                        }
                                        <td colSpan={27} style={{ fontSize: 16, fontWeight: 700 }}>
                                                금 {geKoreanNumber(values*10000)}원은&nbsp;
                                                {values1}년 &nbsp;
                                                {values2}월 &nbsp;
                                                {values3}일에 지불한다.
                                                ({rowspan}차중 {i+1}차)
                                        </td>
                                    </tr>
                                );
                            }

                        })}

                        <tr>
                            <th className='justifys' colSpan={3} >잔 금</th>
                            <td colSpan={27} style={{ fontSize: 16, fontWeight: 700 }}>
                                    금 {geKoreanNumber(inputArr?.find(item => item?.keys === '잔금')?.values*10000)} 은   &nbsp; 
                                    {inputArr?.find(item => item?.keys === '잔금년')?.values}년 &nbsp;
                                    {inputArr?.find(item => item?.keys === '잔금월')?.values}월 &nbsp;
                                    {inputArr?.find(item => item?.keys === '잔금일')?.values}일에 지불한다.
                            </td>
                        </tr>     
                        {sell_type === '월세' &&    
                        <tr>
                            <th className='justifys' colSpan={3} >차 임</th>
                            <td colSpan={27}>
                                <div className='displayflexstart' style={{ gap: 4 }}>
                                    금 {geKoreanNumber(inputArr?.find(item => item?.keys === '차임')?.values*10000)} 은 매월 
                                    {inputArr?.find(item => item?.keys === '차임일')?.values}일에 지불한다.
                                </div>
                            </td>
                        </tr> }               
                        <tr>
                            <td colSpan={30} className='contractmoreText' style={{ padding: 0 }} >
                                {sell_type === '매매' ?
                                <div style={{ lineHeight: 1.17, gap: 2 }}>
                                    <div>
                                        <p>제 2조</p>
                                        <p style={{ display: 'inline-block'}}>
                                            [소유권 이전 등] 매도인은 매매대금의 잔금 수령과 동시에 매수인에게 소유권이전등기에 필요한 모든 서류를 교부하고 등기절차에 협력하며, 위 부동산의 인도일은 &nbsp;
                                            <b>
                                            {inputArr?.find(item => item?.keys === '부동산인도일년')?.values}년 &nbsp;
                                            {inputArr?.find(item => item?.keys === '부동산인도일월')?.values}월  &nbsp;
                                            {inputArr?.find(item => item?.keys === '부동산인도일일')?.values}일</b>로 한다.
                                        </p>
                                    </div>
                                    <div>
                                        <p>제 3조</p>
                                        <p>[제한물권 등의 소멸] 매도인은 위의 부동산에 설정된 저당권, 지상권, 임차권 등 소유권의 행사를 제한하는 사유가 있거나, 제세공과 기타 부담금의 미납 등이 있을 때에는 잔금 수수일까지 그 권리의 하자 및 부담 등을 제거하여 완전한 소유권을 매수인에게 이전한다. 다만, 승계하기로 합의하는 권리 및 금액은 그러하지 아니하다.</p>
                                    </div>
                                    <div>
                                        <p>제 4조</p>
                                        <p>[지방세 등] 위 부동산에 관하여 발생한 수익의 귀속과 제세공과금 등의 부담은 위 부동산의 인도일을 기준으로 하되, 지방세의 납부의무 및 납부책임은 지방세법의 규정에 의한다.</p>
                                    </div>
                                    <div>
                                        <p>제 5조</p>
                                        <p>[계약의 해제] 매수인이 매도인에게 중도금(중도금이 없을 때에는 잔금)을 지급하기 전까지 매도인은 계약금의 배액을 상환하고, 매수인은 계약금을 포기하고 본 계약을 해제할 수 있다.</p>
                                    </div>
                                    <div>
                                        <p>제 6조</p>
                                        <p>[채무불이행과 손해배상의 예정] 매도인 또는 매수인은 본 계약상의 내용에 대하여 불이행이 있을 경우 그 상대방은 불이행 한 자에 대하여 서면으로 최고하고 계약을 해제할 수 있다. 그리고 계약 당사자는 계약해제에 따른 손해배상을 각각 상대방에게 청구할 수 있으며, 손해배상에 대하여 별도의 약정이 없는 한 계약금을 손해배상의 기준으로 본다.</p>
                                    </div>
                                    <div>
                                        <p>제 7조</p>
                                        <p>[중개보수] 개업공인중개사는 매도인 또는 매수인의 본 계약 불이행에 대하여 책임을 지지 않는다. 또한 중개보수는 본 계약 체결에 따라 계약 당사자 쌍방이 각각 지급하며, 개업공인중개사의 고의나 과실 없이 본 계약이 무효, 취소 또는 해제 되어도 중개보수는 지급한다. 공동중개인 경우에 매도인과 매수인은 자신이 의뢰한 개업공인중개사에게 각각 중개보수를 지급한다.</p>
                                    </div>
                                    <div>
                                        <p>제 8조</p>
                                        <p>[중개보수 외] 매도인 또는 매수인이 본 계약 이외의 업무를 의뢰한 경우, 이에 관한 보수는 중개수수료와는 별도로 지급하며 그 금액은 합의에 의한다.</p>
                                    </div>
                                    <div>
                                        <p style={{ }}>제 9조</p>
                                        <p style={{ display: 'inline-block'}}>
                                            [중개대상물확인·설명서 교부 등] 개업공인중개사는 중개대상물 확인·설명서를 작성하고 업무보증관계증서(공제증서 등) 사본을 첨부하여 계약체결과 동시에 거래당사자 쌍방에게 교부한다. (교부일자: &nbsp;
                                            <b>
                                            {inputArr?.find(item => item?.keys === '쌍방교부년')?.values}년 &nbsp;
                                            {inputArr?.find(item => item?.keys === '쌍방교부월')?.values}월  &nbsp;
                                            {inputArr?.find(item => item?.keys === '쌍방교부일')?.values}일</b>)
                                        </p>
                                    </div>
                                </div>
                                :
                                <div style={{ lineHeight: 1.17, gap: 2 }}>
                                    <div>
                                        <p>제 2조</p>
                                        <p style={{ display: 'inline-block'}}>
                                            [존속기간] 임대인은 위 부동산을 임대차 목적대로 사용할 수 있는 상태로 &nbsp;
                                            <b>
                                            {inputArr?.find(item => item?.keys === '부동산인도일년')?.values}년 &nbsp;
                                            {inputArr?.find(item => item?.keys === '부동산인도일월')?.values}월  &nbsp;
                                            {inputArr?.find(item => item?.keys === '부동산인도일일')?.values}일</b>까지 임차인에게 인도하며, 임대차 기간은 인도일로부터 &nbsp;
                                            <b>
                                            {inputArr?.find(item => item?.keys === '부동산임대차인도일년')?.values}년 &nbsp;
                                            {inputArr?.find(item => item?.keys === '부동산임대차인도일월')?.values}월  &nbsp;
                                            {inputArr?.find(item => item?.keys === '부동산임대차인도일일')?.values}일</b>({inputArr?.find(item => item?.keys === '부동산임대차인도일개월')?.values} 개월)까지로 한다.
                                        </p>
                                    </div>
                                    <div>
                                        <p>제 3조</p>
                                        <p>[용도변경 및 전대 등] 임차인은 임대인의 동의 없이 위 부동산의 용도나 구조를 변경하거나 전대, 임차권 양도 또는 담보제공을 하지 못하며 임대차 목적 이외의 용도로 사용할 수 없다.</p>
                                    </div>
                                    <div>
                                        <p>제 4조</p>
                                        <p>[계약의 해지] 임대인은 임차인이 2기의 차임액에 달하도록 연체하거나, 제3조를 위반하였을 즉시 본 계약을 해지할 수 있다.</p>
                                    </div>
                                    <div>
                                        <p>제 5조</p>
                                        <p>[계약의 종료] 임대차계약이 종료된 경우 임차인은 위 부동산을 원상으로 회복하여 임대인에게 반환한다. 이러한 경우 임대인은 보증금을 임차인에게 반환하고, 연체 임대료 또는 손해배상금이 있을 때는 이들을 제하고 그 잔액을 반환한다.</p>
                                    </div>
                                    <div>
                                        <p>제 6조</p>
                                        <p>[계약의 해제] 임차인이 임대인에게 중도금(중도금이 없을 때는 잔금)을 지급하기 전까지 임대인은 계약금의 배액을 상환하고, 임차인은 계약금을 포기하고 이 계약을 해제할 수 있다.</p>
                                    </div>
                                    <div>
                                        <p>제 7조</p>
                                        <p>[채무불이행과 손해배상의 예정] 임대인 또는 임차인은 본 계약상의 내용에 대하여 불이행이 있을 경우 그 상대방은 불이행 한 자에 대하여 서면으로 최고하고 계약을 해제할 수 있다. 이 경우 계약 당사자는 계약해제에 따른 손해배상을 각각 상대방에게 청구할 수 있으며, 손해배상에 대하여 별도의 약정이 없는 한 계약금을 손해배상의 기준으로 본다.</p>
                                    </div>
                                    <div>
                                        <p>제 9조</p>
                                        <p>[중개보수] 개업공인중개사는 임대인 또는 임차인의 본 계약 불이행에 대하여 책임을 지지 않는다. 또한 중개보수는 본 계약 체결에 따라 계약 당사자 쌍방이 각각 지급하며, 개업공인중개사의 고의나 과실 없이 본 계약이 무효, 취소 또는 해제 되어도 중개보수는 지급한다. 공동중개인 경우에 임대인과 임차인은 자신이 중개 의뢰한 개업공인중개사에게 각각 중개보수를 지급한다.</p>
                                    </div>
                                    <div>
                                        <p style={{ }}>제 9조</p>
                                        <p style={{ display: 'inline-block'}}>
                                        [중개대상물확인·설명서 교부 등] 개업공인중개사는 중개대상물 확인·설명서를 작성하고 업무보증관계증서(공제증서 등) 사본을 첨부하여 계약체결과 동시에 거래당사자 쌍방에게 교부한다.(교부일자: &nbsp;
                                            <b>
                                            {inputArr?.find(item => item?.keys === '쌍방교부년')?.values}년 &nbsp;
                                            {inputArr?.find(item => item?.keys === '쌍방교부월')?.values}월  &nbsp;
                                            {inputArr?.find(item => item?.keys === '쌍방교부일')?.values}일</b>)
                                        </p>
                                    </div>
                                </div>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={30} style={{ padding: 0, verticalAlign: 'top', overflow: 'hidden' }}>
                                <p style={{ padding: '5px 10px 0px', fontSize: 12  }}>특약사항</p>
                                <div style={{ padding: '5px 10px 0px', whiteSpace: 'pre-wrap', height: commentHeight, overflow: 'hidden' }}>
                                    {inputArr?.find(item => item?.keys === '특약사항')?.values[0]?.values}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={30} style={{ borderBottom: 0 }}>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 20 }}
                                >
                                    <div className='fontsize12'>
                                        본 계약을 증명하기 위하여 계약 당사자가 이의 없음을 확인하고 각각 서명 또는 날인한다.
                                    </div>
                                    <div
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}
                                    >
                                        {inputArr?.find(item => item?.keys === '날인일년')?.values}년&nbsp;
                                        {inputArr?.find(item => item?.keys === '날인일월')?.values}월&nbsp;
                                        {inputArr?.find(item => item?.keys === '날인일')?.values}일        
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>          
            </div>
            {/* 주민번호관련 */}
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: 20, marginTop: 0}} >
                <div 
                    className='fontsize12' style={{ width: '100%' }}
                >
                    <table className='contractTable' style={{ borderTop: 0}}>
                        <tr><td colSpan={30} style={{ height: 1, padding: 0}}></td></tr>

                        {inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => {
                            let rowspan = inputArr?.find(item => item?.keys === '매도인')?.values?.length;
                            let indexNumber = i;
                            if(i > 0) return;
                            return (
                                <>
                                    <tr>
                                        <th className='justifys' colSpan={1} style={{ whiteSpace: 'pre-wrap'}} rowSpan={2}>{sell_type === '매매' ? '매도인' : '임대인'}</th>
                                        <th className='justifys' colSpan={4} >주 소</th>
                                        <td colSpan={23}>
                                            {x?.values?.find(item => item?.keys === '매도인주소')?.values}                           
                                        </td>
                                        <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                            (인)
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '매도인주민번호선택')?.values}</th>
                                        <td colSpan={8}>
                                            {x?.values?.find(item => item?.keys === '매도인주민번호')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >전 화</th>
                                        <td colSpan={6}>
                                            {x?.values?.find(item => item?.keys === '매도인전화')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >성 명</th>
                                        <td colSpan={5}>
                                            {x?.values?.find(item => item?.keys === '매도인성명')?.values}
                                        </td>
                                    </tr>             
                                    {x?.subflag === true &&
                                    <>
                                    <tr>
                                        <th className='justifys' colSpan={1} style={{ whiteSpace: 'pre-wrap'}} rowSpan={2}>
                                            {x?.values?.find(item => item?.keys === '대리인')?.values}
                                        </th>
                                        <th className='justifys' colSpan={4} >주 소</th>
                                        <td colSpan={23}>
                                            {x?.values?.find(item => item?.keys === '대리인주소')?.values}                           
                                        </td>
                                        <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                            (인)
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '대리인주민번호선택')?.values}</th>
                                        <td colSpan={8}>
                                            {x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >전 화</th>
                                        <td colSpan={6}>
                                            {x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >성 명</th>
                                        <td colSpan={5}>
                                            {x?.values?.find(item => item?.keys === '대리인성명')?.values}
                                        </td>
                                    </tr>                                       
                                    </>                                    
                                    }                   
                                </>
                            );
                        })}


                        {inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => {
                            let rowspan = inputArr?.find(item => item?.keys === '매수인')?.values?.length;
                            let indexNumber = i;
                            if(i > 0) return;
                            return (
                                <>
                                    <tr>
                                        <th className='justifys' style={{ whiteSpace: 'pre-wrap'}} rowSpan={2}>{sell_type === '매매' ? '매수인' : '임차인'}</th>
                                        <th className='justifys' colSpan={4} >주 소</th>
                                        <td colSpan={23}>
                                            {x?.values?.find(item => item?.keys === '매수인주소')?.values}
                                        </td>
                                        <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                            (인)
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '매수인주민번호선택')?.values}</th>
                                        <td colSpan={8}>
                                            {x?.values?.find(item => item?.keys === '매수인주민번호')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >전 화</th>
                                        <td colSpan={6}>
                                            {x?.values?.find(item => item?.keys === '매수인전화')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >성 명</th>
                                        <td colSpan={5}>
                                            {x?.values?.find(item => item?.keys === '매수인성명')?.values}
                                        </td>
                                    </tr>     
                                    {x?.subflag === true &&
                                    <>       
                                    <tr>
                                        <th className='justifys' style={{ whiteSpace: 'pre-wrap'}} rowSpan={2}>
                                            {x?.values?.find(item => item?.keys === '대리인')?.values}
                                        </th>
                                        <th className='justifys' colSpan={4} >주 소</th>
                                        <td colSpan={23}>
                                            {x?.values?.find(item => item?.keys === '대리인주소')?.values}
                                        </td>
                                        <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                            (인)
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '대리인주민번호선택')?.values}</th>
                                        <td colSpan={8}>
                                            {x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >전 화</th>
                                        <td colSpan={6}>
                                            {x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                        </td>
                                        <th className='justifys' colSpan={2} >성 명</th>
                                        <td colSpan={5}>
                                            {x?.values?.find(item => item?.keys === '대리인성명')?.values}
                                        </td>
                                    </tr>                                                         
                                    </>
                                    }
                                </>
                            );
                        })}
                        <tr>
                            <th className='justifys' style={{ whiteSpace: 'pre-wrap', lineHeight: '10px', fontSize: 11}} rowSpan={3}>
                                개업공인중개사
                            </th>
                            <th className='justifys' colSpan={4} >사 무 소 소 재 지</th>
                            <td colSpan={25}>
                                {inputArr?.find(item => item?.keys === '개중사무소소재지1')?.values}
                            </td>
                        </tr>
                        <tr>
                            <th className='justifys' colSpan={4} >사 무 소 명 칭</th>
                            <td colSpan={14}>
                                {inputArr?.find(item => item?.keys === '개중사무소명칭1')?.values}
                            </td>
                            <th className='justifys' colSpan={4} >대 표 자 명</th>
                            <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                            <td colSpan={5} style={{ textAlign: 'right'}}>
                                <div className='displayflexstart' style={{ gap: 4 }}>
                                    <div style={{ width: 200, color: 'red' }}>
                                        자필서명
                                    </div>                         
                                    (인)
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th className='justifys' colSpan={4} >전 화 번 호</th>
                            <td colSpan={5}>
                                {inputArr?.find(item => item?.keys === '개중전화번호1')?.values}
                            </td>
                            <th className='justifys' colSpan={3} style={{ fontSize: 11 }} >등 록 번 호</th>
                            <td colSpan={6}>
                                {inputArr?.find(item => item?.keys === '개중등록번호1')?.values}
                            </td>
                                                    
                            <th className='justifys' colSpan={4} style={{ fontSize: 11 }}>소 속 공 인 중 개 사</th>
                            <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                            <td colSpan={5} style={{ textAlign: 'right'}}>
                                <div className='displayflexstart' style={{ gap: 4 }}>
                                    <div style={{ width: 200, color: 'red' }}>
                                        자필서명
                                    </div>                         
                                    (인)
                                </div>
                            </td>
                        </tr>
                        {togetherck?.length > 0 &&
                        <>
                        {inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => {
                            let rowspan = inputArr?.find(item => item?.keys === '공동중개')?.values?.length;
                            let indexNumber = i;
                            return;
                            return (
                            <>
                            <tr>
                                <th className='justifys' style={{ whiteSpace: 'pre-wrap', lineHeight: '10px', fontSize: 11}} rowSpan={3}>
                                    개업공인중개사
                                </th>
                                <th className='justifys' colSpan={4} >사 무 소 소 재 지</th>
                                <td colSpan={25}>
                                    {x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.values}
                                </td>
                            </tr>
                            <tr>
                                <th className='justifys' colSpan={4} >사 무 소 명 칭</th>
                                <td colSpan={14}>
                                    {x?.values?.find(item => item?.keys === '공동중개사무소명칭')?.values}
                                </td>
                                <th className='justifys' colSpan={4} >대 표 자 명</th>
                                <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                                <td colSpan={5} style={{ textAlign: 'right'}}>
                                    <div className='displayflexstart' style={{ gap: 4 }}>
                                        <div style={{ width: 200, color: 'red' }}>
                                            자필서명
                                        </div>                        
                                        (인)
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th className='justifys' colSpan={4} >전 화 번 호</th>
                                <td colSpan={5}>
                                    {x?.values?.find(item => item?.keys === '공동중개전화번호')?.values}
                                </td>
                                <th className='justifys' colSpan={3} style={{ fontSize: 11 }} >등 록 번 호</th>
                                <td colSpan={6}>
                                    {x?.values?.find(item => item?.keys === '공동중개등록번호')?.values}
                                </td>
                                                        
                                <th className='justifys' colSpan={4} style={{ fontSize: 11 }}>소 속 공 인 중 개 사</th>
                                <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                                <td colSpan={5} style={{ textAlign: 'right'}}>
                                    <div className='displayflexstart' style={{ gap: 4 }}>
                                        <div style={{ width: 200, color: 'red' }}>
                                            자필서명
                                        </div>                        
                                        (인)
                                    </div>
                                </td>
                            </tr>      
                            </>
                            );
                        })}
                        </>
                        }              
                    </table>
                </div>          
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: 3,}}>
                {totalpage}쪽 중 1쪽(Em2n111z99pp1y)
            </div>
            {pageArr?.map((x, i) => {
                console.log(x);
                let subheight = 174;
                let subheightplus = 174;
                                
                return (
                <>
                    <div style={{ display: 'flex', height: 1103, overflow: 'hidden', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column', }} >
                        <div 
                            className='fontsize12' 
                            style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8, marginBottom: 10
                            }}
                        >
                            <div style={{ fontSize: 20, fontWeight: 700}}>
                                {category} {sell_type} 계약서 별지
                            </div>
                        </div>
                        
                        <div 
                            className='fontsize12' style={{ width: '100%', marginBottom: 10}}
                        >
                            <table className='contractTable'>
                                <tr>
                                    <th colSpan={30}>
                                        <p>매도인과 매수인 쌍방은 아래 표시 부동산에 관하여 다음 계약 내용과 같이 매매계약을 체결한다.</p>
                                        <p className='bolds margint8'>1.부동산의 표시</p>
                                    </th>
                                </tr>
                                <tr>
                                    <th className='justifys' colSpan={3}>소 재 지</th>
                                    <td colSpan={27}>
                                        {inputArr?.find(item => item?.keys === '소재지')?.values}&nbsp;
                                        {inputArr?.find(item => item?.keys === '소재지동')?.values}동&nbsp;
                                        {inputArr?.find(item => item?.keys === '소재지호')?.values}호
                                    </td>
                                </tr>
                                {category === '일반건물' &&
                                <tr>
                                    <th className='justifys' colSpan={3} >토 지</th>
                                    <th className='justifys' colSpan={2} >지 목</th>
                                    <td colSpan={17}>
                                        {inputArr?.find(item => item?.keys === '토지지목')?.values}
                                    </td>
                                    <th className='justifys' colSpan={3} >면 적</th>
                                    <td colSpan={5}>
                                        {inputArr?.find(item => item?.keys === '토지면적')?.values}㎡
                                    </td>
                                </tr>}
                                {category === '집합건물' &&
                                <tr>
                                    <th className='justifys' colSpan={3} >대 지 권</th>
                                    <th className='justifys' colSpan={2} >목 적</th>
                                    <td colSpan={4}>
                                        {inputArr?.find(item => item?.keys === '토지지목')?.values}
                                    </td>
                                    <th className='justifys' colSpan={2} >면 적</th>
                                    <td colSpan={4}>
                                        {inputArr?.find(item => item?.keys === '대지권면적')?.values}㎡
                                    </td>
                                    <th className='justifys' colSpan={3} >대지권종류</th>
                                    <td colSpan={4}>
                                        {inputArr?.find(item => item?.keys === '대지권종류')?.values}
                                    </td>
                                    <th className='justifys' colSpan={3} >대지권비율</th>
                                    <td colSpan={5}>
                                        {inputArr?.find(item => item?.keys === '대지권비율')?.values}
                                    </td>
                                </tr>      
                                }              
                                <tr>
                                    <th className='justifys' colSpan={3} >건 물</th>
                                    <th className='justifys' colSpan={2} >구 조</th>
                                    <td colSpan={4}>
                                        {inputArr?.find(item => item?.keys === '건물구조')?.values}
                                    </td>
                                    <th className='justifys' colSpan={2} >용 도</th>
                                    <td colSpan={4}>
                                        {inputArr?.find(item => item?.keys === '건물용도')?.values}
                                    </td>
                                    <th className='justifys' colSpan={3} style={{ letterSpacing: -1 }}>전 용 면 적</th>
                                    <td colSpan={4}>
                                        {inputArr?.find(item => item?.keys === '건물전용면적')?.values}㎡
                                    </td>
                                    <th className='justifys' colSpan={3} >연 면 적</th>
                                    <td colSpan={5}>
                                        {inputArr?.find(item => item?.keys === '건물연면적')?.values}㎡
                                    </td>
                                </tr>
                                {(sell_type === '전세' || sell_type === '월세') &&
                                <tr>
                                    <th className='justifys' colSpan={3} style={{ letterSpacing: -1 }} >임대할 부분</th>
                                    <td colSpan={19}>
                                        {inputArr?.find(item => item?.keys === '임대할부분')?.values}
                                    </td>
                                    <th className='justifys' colSpan={3} >면 적</th>
                                    <td colSpan={5}>
                                        {inputArr?.find(item => item?.keys === '임대할면적')?.values}㎡
                                    </td>
                                </tr>
                                }                                
                            </table>
                        </div> 
                        {(inputArr?.find(item => item?.keys === '중도금')?.values?.length - midpricecount) > 0 && subheightplus < 1116 &&
                        <>
                        <div 
                            className='fontsize12' style={{ width: '100%', }}
                        >
                            <table className='contractTable'>
                                {inputArr?.find(item => item?.keys === '중도금' )?.values?.map((x, i) => {
                                    if(i < 1) return;

                                    let rowspan = inputArr?.find(item => item?.keys === '중도금')?.values?.length;
                                    if(midpricecount >= rowspan){
                                        return;
                                    }
                                    let values = x?.values?.find(item => item?.keys === '중도금')?.values;
                                    let values1 = x?.values?.find(item => item?.keys === '중도금지불일년')?.values;
                                    let values2 = x?.values?.find(item => item?.keys === '중도금지불일월')?.values;
                                    let values3 = x?.values?.find(item => item?.keys === '중도금지불일일')?.values;
                                    let indexNumber = i;
                                    let countHeight = 27.5 + (subheight);
                                    if(countHeight > 1116){
                                        subheightplus = countHeight;
                                        return;
                                    }
                                    subheight = countHeight;
                                    midpricecount = midpricecount+1;
                                    // let midpricecount = inputArr?.find(item => item?.keys === '중도금')?.values;
                                    // let commentcount = inputArr?.find(item => item?.keys === '특약사항')?.values;
                                    // let buyercount = inputArr?.find(item => item?.keys === '매도인')?.values;
                                    // let sellercount = inputArr?.find(item => item?.keys === '매수인')?.values;
                                    // let togethercount = inputArr?.find(item => item?.keys === '공동중개')?.values;


                                    return (
                                        <tr>
                                            <th className='justifys' style={{ width: 77 }}>중 도 금</th>
                                            <td style={{ fontSize: 16, fontWeight: 700 }}>
                                                    금 {geKoreanNumber(values*10000)}원은&nbsp;
                                                    {values1}년 &nbsp;
                                                    {values2}월 &nbsp;
                                                    {values3}일에 지불한다.
                                                    ({rowspan}차중 {i+1}차)
                                            </td>
                                        </tr>    
                                    );
                                })}
                            </table>
                        </div>
                        </>
                        }
                        {(inputArr?.find(item => item?.keys === '특약사항')?.values?.length - commentcount) > 0 && subheightplus < 1116 &&
                        <>

                        <div 
                            className='fontsize12' style={{ width: '100%', }}
                        >
                            <table className='contractTable'>
                                {inputArr?.find(item => item?.keys === '특약사항')?.values?.map((x, i) => {
                                    if(i < 1) return;
                                    if(commentcount >= inputArr?.find(item => item?.keys === '특약사항')?.values?.length){
                                        return;
                                    }
                                    if(i < commentcount){
                                        return;
                                    }
                                    let countHeight = 305.5 + (subheight);
                                    if(countHeight > 1116){
                                        subheightplus = countHeight;
                                        return;
                                    }
                                    subheight = countHeight;
                                    commentcount = commentcount+1;
                                    return (
                                        <tr>
                                            <td colSpan={30} style={{ padding: 0, verticalAlign: 'top', overflow: 'hidden' }}>
                                                <p style={{ padding: '5px 10px 0px', fontSize: 12  }}>특약사항</p>
                                                <div style={{ padding: '2px 10px 0px', whiteSpace: 'pre-wrap', height: 285 }}>
                                                    {x?.values}
                                                </div>
                                            </td>
                                        </tr>     
                                    );
                                })}
                            </table>
                        </div>
                        </>
                        }

                        {(inputArr?.find(item => item?.keys === '매도인')?.values?.length - buyercount) > 0 && subheightplus < 1116 &&
                        <>
                        <div 
                            className='fontsize12' style={{ width: '100%', }}
                        >
                            <table className='contractTable'>
                                {inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => {
                                    if(i < 1) return;
                                    if(buyercount >= inputArr?.find(item => item?.keys === '매도인')?.values?.length){
                                        return;
                                    }
                                    if(i < buyercount){
                                        return;
                                    }
                                    let countHeight = (x?.subflag ? 98 : 49) + (subheight);
                                    if(countHeight > 1116){
                                        subheightplus = countHeight;
                                        return;
                                    }
                                    subheight = countHeight;
                                    buyercount = buyercount+1;
                                    return (
                                    <>
                                        <tr>
                                            <th className='justifys' colSpan={1} style={{ width: 26, whiteSpace: 'pre-wrap'}} rowSpan={2}>{sell_type === '매매' ? '매도인' : '임대인'}</th>
                                            <th className='justifys' colSpan={4} style={{ width: 103 }}>주 소</th>
                                            <td colSpan={23}>
                                                {x?.values?.find(item => item?.keys === '매도인주소')?.values}                           
                                            </td>
                                            <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                                (인)
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '매도인주민번호선택')?.values}</th>
                                            <td colSpan={8}>
                                                {x?.values?.find(item => item?.keys === '매도인주민번호')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >전 화</th>
                                            <td colSpan={6}>
                                                {x?.values?.find(item => item?.keys === '매도인전화')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >성 명</th>
                                            <td colSpan={5}>
                                                {x?.values?.find(item => item?.keys === '매도인성명')?.values}
                                            </td>
                                        </tr>             
                                        {x?.subflag === true &&
                                        <>
                                        <tr>
                                            <th className='justifys' colSpan={1} style={{ whiteSpace: 'pre-wrap'}} rowSpan={2}>
                                                {x?.values?.find(item => item?.keys === '대리인')?.values}
                                            </th>
                                            <th className='justifys' colSpan={4} >주 소</th>
                                            <td colSpan={23}>
                                                {x?.values?.find(item => item?.keys === '대리인주소')?.values}                           
                                            </td>
                                            <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                                (인)
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '대리인주민번호선택')?.values}</th>
                                            <td colSpan={8}>
                                                {x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >전 화</th>
                                            <td colSpan={6}>
                                                {x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >성 명</th>
                                            <td colSpan={5}>
                                                {x?.values?.find(item => item?.keys === '대리인성명')?.values}
                                            </td>
                                        </tr>                                       
                                        </>                                    
                                        }   
                                    </>
                                    );
                                })}
                            </table>
                        </div>
                        </>
                        }

                        {(inputArr?.find(item => item?.keys === '매수인')?.values?.length - sellercount) > 0 && subheightplus < 1116 &&
                        <>
                        <div 
                            className='fontsize12' style={{ width: '100%', }}
                        >
                            <table className='contractTable'>
                                {inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => {
                                    if(i < 1) return;
                                    if(sellercount >= inputArr?.find(item => item?.keys === '매수인')?.values?.length){
                                        return;
                                    }
                                    if(i < sellercount){
                                        return;
                                    }
                                    let countHeight = (x?.subflag ? 98 : 49) + (subheight);
                                    if(countHeight > 1116){
                                        subheightplus = countHeight;
                                        return;
                                    }
                                    subheight = countHeight;
                                    sellercount = sellercount+1;
                                    return (
                                        <>
                                        <tr>
                                            <th className='justifys' style={{ width: 26, whiteSpace: 'pre-wrap'}} rowSpan={2}>{sell_type === '매매' ? '매수인' : '임차인'}</th>
                                            <th className='justifys' colSpan={4} style={{ width: 103 }} >주 소</th>
                                            <td colSpan={23}>
                                                {x?.values?.find(item => item?.keys === '매수인주소')?.values}
                                            </td>
                                            <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                                (인)
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '매수인주민번호선택')?.values}</th>
                                            <td colSpan={8}>
                                                {x?.values?.find(item => item?.keys === '매수인주민번호')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >전 화</th>
                                            <td colSpan={6}>
                                                {x?.values?.find(item => item?.keys === '매수인전화')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >성 명</th>
                                            <td colSpan={5}>
                                                {x?.values?.find(item => item?.keys === '매수인성명')?.values}
                                            </td>
                                        </tr>     
                                        {x?.subflag === true &&
                                        <>       
                                        <tr>
                                            <th className='justifys' style={{ whiteSpace: 'pre-wrap'}} rowSpan={2}>
                                                {x?.values?.find(item => item?.keys === '대리인')?.values}
                                            </th>
                                            <th className='justifys' colSpan={4} >주 소</th>
                                            <td colSpan={23}>
                                                {x?.values?.find(item => item?.keys === '대리인주소')?.values}
                                            </td>
                                            <td colSpan={2} rowSpan={2} style={{ textAlign: 'center' }}>
                                                (인)
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='justifys' colSpan={4} >{x?.values?.find(item => item?.keys === '대리인주민번호선택')?.values}</th>
                                            <td colSpan={8}>
                                                {x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >전 화</th>
                                            <td colSpan={6}>
                                                {x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                            </td>
                                            <th className='justifys' colSpan={2} >성 명</th>
                                            <td colSpan={5}>
                                                {x?.values?.find(item => item?.keys === '대리인성명')?.values}
                                            </td>
                                        </tr>                                                         
                                        </>
                                        }
                                    </>
                                    );
                                })}
                            </table>
                        </div>
                        </>
                        }

                        {(inputArr?.find(item => item?.keys === '공동중개')?.values?.length - togethercount) > 0 && subheightplus < 1116 &&
                        <>
                        <div 
                            className='fontsize12' style={{ width: '100%', }}
                        >
                            <table className='contractTable'>
                                {inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => {
                                    if(togethercount >= inputArr?.find(item => item?.keys === '공동중개')?.values?.length){
                                        return;
                                    }
                                    if(i < togethercount){
                                        return;
                                    }
                                    let countHeight = 78 + (subheight);
                                    if(countHeight > 1116){
                                        subheightplus = countHeight;
                                        return;
                                    }
                                    subheight = countHeight;
                                    togethercount = togethercount+1;
                                    return (
                                        <>
                                        <tr>
                                            <th className='justifys' style={{ width: 26, whiteSpace: 'pre-wrap', lineHeight: '10px', fontSize: 11}} rowSpan={3}>
                                                개업공인중개사
                                            </th>
                                            <th className='justifys' colSpan={4} style={{ width: 103 }}>사 무 소 소 재 지</th>
                                            <td colSpan={25}>
                                                {x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.values}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='justifys' colSpan={4} >사 무 소 명 칭</th>
                                            <td colSpan={14}>
                                                {x?.values?.find(item => item?.keys === '공동중개사무소명칭')?.values}
                                            </td>
                                            <th className='justifys' colSpan={4} >대 표 자 명</th>
                                            <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                                            <td colSpan={5} style={{ textAlign: 'right'}}>
                                                <div className='displayflexstart' style={{ gap: 4 }}>
                                                    <div style={{ width: 200, color: 'red' }}>
                                                        자필서명
                                                    </div>                        
                                                    (인)
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th className='justifys' colSpan={4} >전 화 번 호</th>
                                            <td colSpan={5}>
                                                {x?.values?.find(item => item?.keys === '공동중개전화번호')?.values}
                                            </td>
                                            <th className='justifys' colSpan={3} style={{ fontSize: 11 }} >등 록 번 호</th>
                                            <td colSpan={6}>
                                                {x?.values?.find(item => item?.keys === '공동중개등록번호')?.values}
                                            </td>
                                                                    
                                            <th className='justifys' colSpan={4} style={{ fontSize: 11 }}>소 속 공 인 중 개 사</th>
                                            <th className='justifys' colSpan={2} style={{ fontSize: 10, letterSpacing: -1, padding: 2 }} >서명 및 날인</th>
                                            <td colSpan={5} style={{ textAlign: 'right'}}>
                                                <div className='displayflexstart' style={{ gap: 4 }}>
                                                    <div style={{ width: 200, color: 'red' }}>
                                                        자필서명
                                                    </div>                        
                                                    (인)
                                                </div>
                                            </td>
                                        </tr>      
                                        </>
                                    );
                                })}
                            </table>
                        </div>
                        </>
                        }
                                                
                    </div>

                                                         
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                        {totalpage}쪽 중 {x?.page+1}쪽(Em2n111z99pp1y)
                    </div>                     
                </>
                );
            })}
                    
        </div>
        </>
    )    
}